import React, { useCallback } from "react";
import { push } from "connected-react-router";
import { connect } from "react-redux";
import { useIntl } from "react-intl";
import { Row, Col } from "antd";

import TableHeader from "../../app/generic/tableHeader";
import ExportButton from "../../app/generic/exportButton";
import TooltipButton from "../../app/generic/tooltipButton";
import SelectAllButton from "../../app/generic/selectAllButton";
import { exportEntities } from "../../../modules/prints/pdfExport";
import FilterButton from "../../app/generic/tableFilter/filterButton";
import { exportAddressDataToExcel } from "../../../modules/prints/excelWork";

function AddressListHeader({
  push,
  addresses,
  showFilter,
  allSelected,
  onDeleteClick,
  onSelectClick,
  onFilterClick,
  workAddresses,
  disabledOptions,
}) {
  const intl = useIntl();
  const handleNewClick = useCallback(() => {
    push("/new-customer");
  }, [push]);

  const handleImportClick = useCallback(() => {
    push("/customer-import");
  }, [push]);

  return (
    <TableHeader
      equal
      title={intl.formatMessage({
        id: "customer.list",
        defaultMessage: "Seznam zákazníků",
      })}
      left={
        <Row type="flex" gutter={10}>
          <Col>
            <SelectAllButton
              allSelected={allSelected}
              onClick={onSelectClick}
            />
          </Col>
          <Col>
            <FilterButton showFilter={showFilter} onClick={onFilterClick} />
          </Col>
          <Col>
            <TooltipButton
              icon="plus"
              text={intl.formatMessage({
                id: "customer.add",
                defaultMessage: "Nový zákazník",
              })}
              onClick={handleNewClick}
            />
          </Col>
        </Row>
      }
      right={
        <Row type="flex" align="middle" justify="end" gutter={10}>
          <Col>
            <TooltipButton
              icon="delete"
              onClick={onDeleteClick}
              title={intl.formatMessage({
                id: "customer.bulkDelete",
                defaultMessage: "hromadné smazání zákazníků",
              })}
            />
          </Col>
          <Col>
            <TooltipButton
              icon="import"
              text={intl.formatMessage({
                id: "customer.import",
                defaultMessage: "Import zákazníků",
              })}
              onClick={handleImportClick}
            />
          </Col>
          <Col>
            <ExportButton
              address
              entity={intl.formatMessage({
                id: "customer.exportWhom",
                defaultMessage: "zákazníky",
              })}
              entities={addresses}
              text={intl.formatMessage({
                id: "customer.export",
                defaultMessage: "Export zákazníků",
              })}
              disabled={disabledOptions}
              workEntities={workAddresses}
              entitiesToPdf={exportEntities}
              entitiesToExcel={exportAddressDataToExcel}
            />
          </Col>
        </Row>
      }
    />
  );
}

export default connect(null, { push })(AddressListHeader);
